import { ArrowBackIcon } from '@chakra-ui/icons';
import { Box, Breadcrumb, BreadcrumbItem, HStack, Icon, IconButton, useMediaQuery } from '@chakra-ui/react';
import Body2 from '@components/typography/Body2';
import { Routes } from '@constants/routes';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import { PlanType } from '@enums/PlanType';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import getPrimaryPlan from '@utils/getPrimaryPlan';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { maSteps, mapdSteps, pdpSteps } from './utils';

const breadCrumbRoutes = {
  PDP: pdpSteps,
  MAPD: mapdSteps,
  MA: maSteps,
};

const AepBreadCrumbs = () => {
  const router = useRouter();
  const [isSmallScreen] = useMediaQuery('(max-width: 767px)');
  const { authenticatedUser: user } = useAuthenticatedContextProvider();
  const plan = getPrimaryPlan(user);
  const steps = breadCrumbRoutes[plan?.plan_type || PlanType.MAPD];
  const currentPath = router.pathname;

  const renderStep = ({ hrefs, label }, index) => {
    const isCurrentStep = hrefs.includes(currentPath);

    return (
      <BreadcrumbItem key={label} isCurrentPage={hrefs.includes(currentPath)} whiteSpace="nowrap">
        <Link href={hrefs[0]} style={{ textDecoration: 'none' }}>
          <HStack>
            <Box
              width="24px"
              minW="24px"
              height="24px"
              bg={isCurrentStep ? 'primary.500' : 'gray.400'}
              borderRadius="50%"
              display="flex"
              justifyContent="center"
              alignItems="center"
              color="white"
              fontWeight={600}
            >
              {index + 1}
            </Box>
            <Body2
              color={isCurrentStep ? 'black' : 'gray.400'}
              fontWeight={600}
              _hover={{ textDecoration: 'underline' }}
            >
              {label}
            </Body2>
          </HStack>
        </Link>
      </BreadcrumbItem>
    );
  };

  // For small screen sizes, only render current step.
  const currentStepIndex = steps.findIndex((step) => step.hrefs.includes(currentPath as Routes));
  const stepComponents = isSmallScreen ? [steps.map(renderStep)[currentStepIndex]] : steps.map(renderStep);
  const backButton =
    currentStepIndex > 0 && isSmallScreen ? (
      <IconButton
        onClick={() => router.back()}
        aria-label="Go back"
        bg="none"
        w={10}
        _hover={{ bg: 'none' }}
        icon={<ArrowBackIcon w={8} h={8} color="primary.500" />}
      />
    ) : null;

  return (
    <>
      <Breadcrumb separator={<Icon as={FontAwesomeIcon} icon={faChevronRight} color="gray.400" />} pb={[4, 4, 10]}>
        {backButton}
        {stepComponents}
      </Breadcrumb>
    </>
  );
};

export default AepBreadCrumbs;
